import { AppRole } from "@/types/role";

const ROLE_PRIORITY: AppRole[] = ["owner", "manager", "staff"];

/**
 * Given an array of role rows from the user_roles table,
 * returns the highest-priority functional role.
 * Priority: owner > manager > staff
 * (super_admin is handled separately by useIsSuperAdmin)
 */
export function getEffectiveRole(roles: { role: string }[]): AppRole | null {
  if (!roles || roles.length === 0) return null;
  for (const priority of ROLE_PRIORITY) {
    if (roles.some(r => r.role === priority)) return priority;
  }
  return (roles[0]?.role as AppRole) ?? null;
}
